// extracted by mini-css-extract-plugin
export var createdDate = "_ew-1";
export var divider = "_ew-2";
export var headerDivider = "_ew-3";
export var messagesCard = "_ew-0";
export var messagesContainer = "_ew-7";
export var messagesContainerWrapper = "_ew-4";
export var pointerCapturingButtonBoxes = "_ew-a";
export var showLeftPanelButton = "_ew-9";
export var showMoreButton = "_ew-c";
export var showMoreButtonContainer = "_ew-b";
export var summaryTitle = "_ew-6";
export var systemMessageCardWrapper = "_ew-d";
export var topButtons = "_ew-8";
export var withPadding = "_ew-5";